<template>
  <OrderTestDialog
    :is-show-dialog="isShowDialog"
    :title="`Permanent Action: Deleting ${markerName} marker`"
    @close="$emit('close')"
  >
    <p>{{ $t("OrderPage[\"If you delete this Micronutrient marker from your favorites, it cannot be added back or ordered individually. Going forward, this marker will only be available as part of the complete Micronutrient test.\"]") }}</p>
    <template #footer>
      <div class="flex flex-row-reverse mt-6">
        <LoginButton @click="$emit('delete')" type="error-2" style="width: 153px;">{{ $t("OrderPage[\"Delete Permanently\"]") }}</LoginButton>
        <LoginButton @click="$emit('close')" class="w-24 mr-4">{{ $t("OrderPage[\"Cancel\"]") }}</LoginButton>
      </div>
    </template>
  </OrderTestDialog>
</template>

<script>
import OrderTestDialog from '@/views/va-orderTest/components/OrderTestDialog.vue';
import LoginButton from '@/views/login/components/LoginButton.vue';

export default {
  emits: ['close', 'delete'],
  components: {
    OrderTestDialog,
    LoginButton
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    markerId: {
      type: Number,
      default: null
    },
    markerName: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.delete-marker-text {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>